import styled from 'styled-components';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1px 29px;
	align-items: center;
	width: 110px;
	height: 30px;
	background-color: #ffffff;
	border-radius: 6px;
	border: 1px solid rgba(0, 0, 0, 0.1);

	.number {
		font-weight: 500;
		color: #000000;
		text-align: center;
	}

	.divider {
		width: 1px;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const StyledRightContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2px;

	.region {
		font-weight: 700;
		font-size: 10px;
		text-align: center;
		color: #000000;
	}

	.code {
		font-weight: 500;
		font-size: 8px;
		text-align: center;
		color: #000000;
		opacity: 0.25;
	}
`;

export { StyledContainer, StyledRightContainer };
